import type { ReactNode } from "react";
import { useEffect } from "react";
import { useAppSelector } from "src/common/state/hooks";
import { getCurrentUser } from "../../features/profile/state/profileSlice";
import i18n, { getBrowserLanguage } from "./i18n";
import { languageConfig } from "../util/langConfig";

interface ITranslatorProps {
  children: ReactNode;
}

const Translator: React.FunctionComponent<ITranslatorProps> = ({ children }) => {
  const currentUser = useAppSelector(getCurrentUser);

  useEffect(() => {
    if (currentUser) {
      const userLocale = languageConfig(currentUser?.preferred_language?.name);
      void i18n.changeLanguage(userLocale);
    } else {
      const defaultLanguage = getBrowserLanguage();
      void i18n.changeLanguage(defaultLanguage);
    }
  }, [currentUser]);

  return children;
};

export default Translator;
